import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import ProjectsService from "../../../services/ProjectsService";
import MediaCenterService from "../../../services/MediaCenterService";

const Projects = () => {
	const [data, setData] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [pathname, setPathname] = useState("");
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const lang = useSelector((state) => state.auth?.lang);
	const Service =
		location?.pathname?.split("/")[1] === "projects"
			? new ProjectsService()
			: new MediaCenterService();

	useEffect(() => {
		setPathname(location?.pathname?.split("/")[1]);
		setShouldUpdate((prev) => !prev);
	}, [location?.pathname]);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang][pathname?.replaceAll("-", "_")]}
						</span>
					</div>
					<div className="add-admin">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								pathname === "media-center"
									? navigate("/media-center/add-media")
									: navigate("/projects/add-project");
							}}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add}{" "}
							{Translate[lang][pathname?.replaceAll("-", "_")]}
						</Button>
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.title}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.image}</strong>
									</th>
									{pathname === "projects" && (
										<th>
											<strong>{Translate[lang]?.link}</strong>
										</th>
									)}
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												Service={Service}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={Service}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
					/>
				</div>
			</div>
		</div>
	);
};
export default Projects;
